<template>
  <v-select :value="value" @input="onInput" :items="filteredListEnteTessere" item-value="tesId" item-text="nome"
    :disabled="disabled" :menu-props="{ maxHeight: '400', maxWidth: '1000', contentClass: 'tessere-ente-picker-menu' }"
    :label="label || $t('card')" required color="primary" :hint="hint" :persistent-hint="persistentHint">
    <template v-slot:prepend-item>
      <div class="tessere-ente-filter-sticky">
        <v-list-item @click.stop class="primary tessere-ente-filter-bar">
          <v-row dense align="center" class="px-2">
            <v-col md="5" cols="12">
              <v-text-field v-model="search" clearable dense dark prepend-inner-icon="mdi-magnify"
                :label="$t('search_by_name')" hide-details="auto" @click.stop></v-text-field>
            </v-col>
            <v-col md="7" cols="12">
              <v-btn-toggle v-model="filterStatus" mandatory dense class="primary darken-1">
                <v-btn value="all" :color="filterStatus === 'all' ? 'success' : undefined">{{ $t("all_f_p") }}</v-btn>
                <v-btn value="valid" :color="filterStatus === 'valid' ? 'success' : undefined">{{ $t("active_f_p") }}</v-btn>
                <v-btn value="invalid" :color="filterStatus === 'invalid' ? 'success' : undefined">{{ $t("inactive_f_p") }}</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </template>
    <template v-slot:item="{ item }">
      <v-icon v-if="item.valid4Season" color="success" class="mr-2">mdi-check-circle</v-icon>
      <v-icon v-else color="error" class="mr-2">mdi-close-circle</v-icon>
      {{ item.nome }}
    </template>
    <template v-slot:selection="{ item }">
      <v-icon v-if="item.valid4Season" color="success" class="mr-2">mdi-check-circle</v-icon>
      <v-icon v-else color="error" class="mr-2">mdi-close-circle</v-icon>
      {{ item.nome }}
    </template>
  </v-select>
</template>
<script>
export default {
  name: "tessere-ente-picker",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listEnteTessere: [],
      search: null,
      filterStatus: "all",
    };
  },
  computed: {
    filteredListEnteTessere() {
      let _ = this;
      let search = (_.search || "").trim().toLowerCase();
      return _.listEnteTessere.filter((tessera) => {
        if (_.filterStatus === "valid" && !tessera.valid4Season) return false;
        if (_.filterStatus === "invalid" && tessera.valid4Season) return false;
        if (search && !String(tessera.nome || "").toLowerCase().includes(search)) return false;
        return true;
      });
    },
    currentEnteTessera() {
      let _ = this;
      if (!_.value) return null;
      return (
        _.listEnteTessere.find((el) => {
          return el.tesId === _.value;
        }) || null
      );
    },
  },
  watch: {
    currentEnteTessera(newVal) {
      this.$emit("change", newVal);
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    loadData() {
      let _ = this;
      _.listEnteTessere = [];
      _.chiamataAxios("GET", "/auth/tesseramenti/listEnteTessere").then((response) => {
        _.listEnteTessere = response.data;
        _.$emit("change", _.currentEnteTessera);
      });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
<style scoped>
.tessere-ente-filter-sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--v-primary-base);
}

.tessere-ente-picker-menu .v-select-list {
  padding: 0 !important
}

.tessere-ente-filter-bar {
  border-radius: 4px;
  opacity: 1 !important;
  background-color: var(--v-primary-base) !important;
}
</style>

